import { render, staticRenderFns } from "./RecentRequestFileList.vue?vue&type=template&id=0f5f7bd4&scoped=true&"
import script from "./RecentRequestFileList.vue?vue&type=script&lang=js&"
export * from "./RecentRequestFileList.vue?vue&type=script&lang=js&"
import style0 from "./RecentRequestFileList.vue?vue&type=style&index=0&id=0f5f7bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f7bd4",
  null
  
)

export default component.exports